exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".build-version{\r\n    margin-left: 30px;\r\n    margin-top: 20px;\r\n    color: #fff;\r\n}\r\n\r\n.sidebar_logout,\r\n.second-level-toggle {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.sidebar-nav{\r\n    position: static;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/sidebar/sidebar.component.css
// module id = 882
// module chunks = 8